import React from "react";
import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import { ModalPickerProps } from "../props";
import ClientList from "./ClientList";
import RemovableClient from "components/Removables/RemovableClient";

interface Props extends ModalPickerProps<server.dto.ClientSmall> {
  preferredClients: server.dto.ClientSmall[]
}


const ClientModalPicker = (props: Props) => {
  const { preferredClients, ...rest } = props;
  return <ModalPickerWithChooseButton
    buttonLabel={RESX.Buttons.btnSelect}
    modalTitle={"Clients"}
    modalSize="mini"
    renderModalContent={(closeModal) => <ClientList
      preferredClients={props.preferredClients}
      onItemSelected={(artist) => {
        closeModal();
        props.onChange(artist);
      }}
    />}
    renderRemovable={(props) => <RemovableClient {...props} />}
    onNewClicked={() => { }}
    {...rest}
  />;
};

export default ClientModalPicker;